$(document).ready(function () {
    const table = $('#stock-items-table');
    if (!table.length) return;
    const form = $('#stock-items-filters');
    const dataTable = table.DataTable({
        processing: true, serverSide: true, pageLength: 25, searchDelay: 350,
        ajax: { url: table.data('url'), data: function (data) { form.serializeArray().forEach(function (field) { data[field.name] = field.value; }); } },
        columns: [
            { data: 'name' }, { data: 'sku' }, { data: 'kind' }, { data: 'tracking_mode' },
            { data: 'unit_name' }, { data: 'transactions' }, { data: 'active' }, { data: 'actions', orderable: false, searchable: false }
        ], language: window.dataTablesRussianLanguage
    });
    form.on('changed.bs.select change', 'select', function () { dataTable.page('first').draw('page'); });
    form.on('submit', function (event) { event.preventDefault(); dataTable.page('first').draw('page'); });
    form.on('click', '.js-table-reset', function () { form[0].reset(); form.find('.selectpicker').selectpicker('refresh'); dataTable.search('').order([0, 'asc']).page('first').draw(); });
});
